module.exports = __webpack_public_path__ + "img/perforaciones_9-16_1080.3ed14657.webp";